<template>
    <span>{{ priceReadable }}</span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    digits: { type: Number, default: 2 },
    given: {
        type: [Number, String],
        default: 0,
        validator: (value) => !isNaN(value - parseFloat(value)),
    },
    calc: Object,
});

// let price = props.given;

// if (!props.given) {
//     price = 2342.55;
// }

const priceReadable = computed(() =>
    new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: props.digits,
        maximumFractionDigits: props.digits,
    }).format(props.given)
);

//   Number(props.given).toLocaleString("de-DE", {
//     minimumFractionDigits: 0,
//     maximumFractionDigits: props.digits,
//   })
</script>


